// extracted by mini-css-extract-plugin
module.exports = {"tag":"TagWrapper_tag__3r2gZ"};